<template>
  <div class="playlist-container">
    <div class="row">
      <div class="col-lg-12 col-md-12 main-page-container">
        <header-menu></header-menu>
        <div class="container">
          <uep-player
            class="mt-4 mb-4"
            v-if="crypted"
            :url="crypted"
            :query="query"
            @readyPlayer="readyPlayer"
            @infoDetails="infoDetails"
          ></uep-player>
          <div class="video-information" v-if="crypted && info.title">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-2 col-md-4 col-sm-6">
                    <div class="thumbnail">
                      <img class="img-fluid" :src="info.image" alt="" />
                    </div>
                  </div>
                  <div class="col-lg-10 col-md-8 col-sm-6">
                    <div class="info-wrapper">
                      <h1 class="title">
                        {{ info.title }}
                      </h1>
                      <p class="description">
                        <span>{{ info.description }}</span>
                      </p>
                      <div class="meta-info-container">
                        <div class="meta-info">
                          <img
                            :alt="$t('titles.video_duration')"
                            :title="$t('titles.video_duration')"
                            class="mr-1"
                            height="16"
                            width="16"
                            src="data:image/svg+xml;base64,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"
                          />
                          <span>{{ info.duree }}</span>
                        </div>
                        <div class="meta-info">
                          <img
                            alt="Nombre de vues"
                            title="Nombre de vues"
                            class="mr-1 ml-3"
                            height="18"
                            width="18"
                            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDU2MSA1NjEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2MSA1NjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIiBjbGFzcz0iIj48Zz48Zz48ZyBpZD0idmlzaWJpbGl0eSI+PHBhdGggZD0iTTI4MC41LDg5LjI1QzE1Myw4OS4yNSw0My4zNSwxNjguMywwLDI4MC41YzQzLjM1LDExMi4yLDE1MywxOTEuMjUsMjgwLjUsMTkxLjI1UzUxNy42NSwzOTIuNyw1NjEsMjgwLjUgICAgQzUxNy42NSwxNjguMyw0MDgsODkuMjUsMjgwLjUsODkuMjV6IE0yODAuNSw0MDhDMjA5LjEsNDA4LDE1MywzNTEuOSwxNTMsMjgwLjVjMC03MS40LDU2LjEtMTI3LjUsMTI3LjUtMTI3LjUgICAgYzcxLjQsMCwxMjcuNSw1Ni4xLDEyNy41LDEyNy41QzQwOCwzNTEuOSwzNTEuOSw0MDgsMjgwLjUsNDA4eiBNMjgwLjUsMjA0Yy00My4zNSwwLTc2LjUsMzMuMTUtNzYuNSw3Ni41ICAgIGMwLDQzLjM1LDMzLjE1LDc2LjUsNzYuNSw3Ni41YzQzLjM1LDAsNzYuNS0zMy4xNSw3Ni41LTc2LjVDMzU3LDIzNy4xNSwzMjMuODUsMjA0LDI4MC41LDIwNHoiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6IzdiN2I3YiIgZGF0YS1vbGRfY29sb3I9IiMxODU5YTEiPjwvcGF0aD48L2c+PC9nPjwvZz4gPC9zdmc+"
                          />
                          <span>{{ info.nb_views }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import HeaderMenu from './HeaderMenu';
import PageFooter from './PageFooter';
import VideoCards from './VideoCards';

export default {
  name: 'PlaylistVideo',
  metaInfo: {
    title: process.env.META_TITLA,
  },
  components: {
    HeaderMenu,
    PageFooter,
    VideoCards,
  },
  data() {
    return {
      player: {},
      info: {},
    };
  },
  watch: {
    playlistFound(playlistFound) {
      if (!playlistFound) {
        this.$router.push({ name: 'error' });
      }
    },
  },
  computed: {
    ...mapGetters({
      playerUrl: 'videos/getPlayerUrl',
      playlistFound: 'videos/getPlaylistFound',
      skinPlayer: 'layout/getCurrentSkinPlayer',
    }),
    crypted() {
      return this.playerUrl.link ? this.playerUrl.link.split('/').reverse()[0] : null;
    },
    query() {
      //todo skin dark
      let skin = this.skinPlayer ? this.skinPlayer : 'dark';
      return { skin: skin, a: false, ...this.$route.query };
    },
  },
  methods: {
    ...mapActions('videos', ['setCurrentVideo', 'getCryptedPlaylistUrl']),
    readyPlayer(param) {
      var self=this;
      this.player = param;
      this.player.on('error', function() {
        if (self.player.options_ && self.player.options_.sources[1]) self.player.src(self.player.options_.sources[1]);
      });
    },
    infoDetails(param) {
      this.info = param;
    },
    updateVideoHeight() {
      const namePlayer = document.querySelector('#name_player');
      try {
        const height = `${namePlayer.offsetWidth * (9 / 16) * 0.8}px`;
        namePlayer.style.height = height;
      } catch (e) {
        setTimeout(() => {
          this.updateVideoHeight();
        }, 3000);
      }
    },
  },
  created() {
    const playlistId = this.$route.params.playlistId.split('.')[0];
    this.getCryptedPlaylistUrl(playlistId);
  },
  mounted() {
    this.$nextTick(() => {
      this.updateVideoHeight();
    });

    window.addEventListener('resize', () => {
      this.updateVideoHeight();
    });
  },
};
</script>

<style scoped lang="scss">
@import '../assets/scss/_variables.scss';
@import "../assets/scss/mix.scss";

.playlist-container {
  /deep/ #uep_player_component {
    position: relative;
    &.isNotRadyPlayer:not(.vjs-tech-flash) {
      height: 250px;
    }
    .vjs-big-play-button {
      transition: none !important;
    }
    .vjs-playlist {
      background-color: #dadada;
      padding-left: 5px;
      &.vjs-playlist-vertical {
        .vjs-playlist-item {
          margin-bottom: 5px;
          &:not(.vjs-selected):before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background-size: 40px;
            background-repeat: no-repeat;
            background-position: center;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDMxNC4wNjggMzE0LjA2OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzE0LjA2OCAzMTQuMDY4OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGc+Cgk8ZyBpZD0iX3gzM181Ni5fUGxheSI+CgkJPGc+CgkJCTxwYXRoIGQ9Ik0yOTMuMDAyLDc4LjUzQzI0OS42NDYsMy40MzUsMTUzLjYxOC0yMi4yOTYsNzguNTI5LDIxLjA2OEMzLjQzNCw2NC40MTgtMjIuMjk4LDE2MC40NDIsMjEuMDY2LDIzNS41MzQgICAgIGM0My4zNSw3NS4wOTUsMTM5LjM3NSwxMDAuODMsMjE0LjQ2NSw1Ny40N0MzMTAuNjI3LDI0OS42MzksMzM2LjM3MSwxNTMuNjIsMjkzLjAwMiw3OC41M3ogTTIxOS44MzQsMjY1LjgwMSAgICAgYy02MC4wNjcsMzQuNjkyLTEzNi44OTQsMTQuMTA2LTE3MS41NzYtNDUuOTczQzEzLjU2OCwxNTkuNzYxLDM0LjE2MSw4Mi45MzUsOTQuMjMsNDguMjYgICAgIGM2MC4wNzEtMzQuNjksMTM2Ljg5NC0xNC4xMDYsMTcxLjU3OCw0NS45NzFDMzAwLjQ5MywxNTQuMzA3LDI3OS45MDYsMjMxLjExNywyMTkuODM0LDI2NS44MDF6IE0yMTMuNTU1LDE1MC42NTJsLTgyLjIxNC00Ny45NDkgICAgIGMtNy40OTItNC4zNzQtMTMuNTM1LTAuODc3LTEzLjQ5Myw3Ljc4OWwwLjQyMSw5NS4xNzRjMC4wMzgsOC42NjQsNi4xNTUsMTIuMTkxLDEzLjY2OSw3Ljg1MWw4MS41ODUtNDcuMTAzICAgICBDMjIxLjAyOSwxNjIuMDgyLDIyMS4wNDUsMTU1LjAyNiwyMTMuNTU1LDE1MC42NTJ6IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iYWN0aXZlLXBhdGgiIHN0eWxlPSJmaWxsOiM0RDRFNEUiIGRhdGEtb2xkX2NvbG9yPSIjNEQ0RDREIj48L3BhdGg+CgkJPC9nPgoJPC9nPgo8L2c+PC9nPiA8L3N2Zz4=);
          }
          &.vjs-selected {
            img {
              opacity: 1;
            }
          }
          .vjs-playlist-duration {
            padding: 2px 5px 2px;
            background-color: rgba(var(--primary-color), 0.6);
            font-size: 0.8em;
            font-weight: 700;
            border-radius: 2px;
          }
          .vjs-playlist-now-playing-text {
            margin: 0.5rem !important;
            padding: 1px 5px 3px !important;
            background-color: rgba(var(--secondary-color), 0.6);
            font-size: 0.8em;
            font-weight: 700;
            border-radius: 2px;
          }
          .vjs-playlist-title-container {
            padding: 0.4rem 0.6rem;
            text-shadow: none !important;
            background-color: rgba(0, 0, 0, 0.6);
            .vjs-up-next-text {
              display: none !important;
            }
            .vjs-playlist-name {
              padding: 0 0 4px 2px;
              font-size: 0.9em;
            }
          }
        }
      }
    }
  }
  .main-page-container {
    min-height: 100vh;
    background-color: #fafafa;

    .video-information {
      padding: 1em;
      background-color: #eceff1;
      border-radius: 0.1em;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      margin-bottom: 2em;
      .info-wrapper {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: space-between;
        width: 100%;
        h1.title {

          text-align: left;
          margin-top: 0;
          font-size: 1.5em;
          @include hasColorTitre(var(--color-title));
          margin-bottom: 0.8em;
          border-bottom: 2px solid var(--secondary-color);
          display: inline-block;
        }
        .meta-info-container {
          display: flex;
          font-size: 0.8em;
          color: #7b7b7b;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.2em;
        }
      }
      .description-wrapper {
        h2.subtitle {
          color: var(--primary-color);
          font-size: 1.2em;
          margin-top: 1em;
        }
        .description span {
          white-space: pre-line;
          width: 100%;
        }
      }
    }
  }
  /deep/ .video-js > button.vjs-big-play-button {
    transition: none !important;
    width: 100px !important;
    height: 100px !important;
    margin-left: -50px;
    margin-top: -50px;
  }
  @media all and (-ms-high-contrast: none) {
    /deep/ {
      .video-js > button.vjs-big-play-button {
        transition: none !important;
      }
    }
  }
}

@media (max-width: 575px) {
  .container {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 992px) {
  /deep/ .uep_player_v2,
  .video-information {
    margin-left: 15px;
    margin-right: 15px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1180px;
  }
}
@media (min-width: 1600px) {
  .container {
    max-width: 1400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlaylistVideo.vue